<template>
  <div class="mt-4">
    <b-row>
      <b-col sm="12" md="8" lg="8" offset-lg="2" offset-md="2">
        <h2>Политика конфиденциальности для доступа к API Google</h2>
        <p>
          iRidium Assistant использует
          <a href="https://developers.google.com/nest/device-access/api"
            >Smart Device Management API</a
          >
          для управления устройствами Google Nest.
        </p>
        <p>
          Дополнительные сведения о том, как его настроить для управления
          устройствами Google Nest, см.
          <a href="https://dev.iridi.com/Nest"
            >Интеграция i3pro с Google Nest</a
          >
        </p>
        <p>
          iRidium Assistant использует приложение "iRidium for Nest" на облачной платформе
          Google. (Это имя вы увидите на экране согласия). Эта интеграция
          регулируется общими политиками, описанными здесь.
        </p>
        <p>
          Использование API Google с iRidium Assistant регулируется
          соответствующими условиями обслуживания каждого API. См.
          <a href="https://developers.google.com/terms"
            >Условия использования API Google</a
          >
        </p>

        <h2>Доступ к пользовательским данным</h2>
        <p>
          Доступ к ресурсам Google осуществляется только с домена и поддоменов
          компании <a href="https://iridi.com/">iridi.com</a>
        </p>
        <p>
          Приложения iRidium использующие сервис iRidium Assistant (iRidium
          server, i3pro, i3lite, i3knx, bus77home, bus77lite) не получают ваши данные или разрешение
          на доступ к вашим данным.
        </p>
        <p>
          Владельцы iRidium проекта получают анонимную агрегированную информацию
          о том какие API и конечные точки используются в
          <a href="https://developers.google.com/nest/device-access/api"
            >Smart Device Management API</a
          >, а также специальный iRidium token управляемого объекта iRidium
          Assistant, который связывает полученные токены через клиент Google
          OAuth
        </p>
        <p>
          iRidium Assistant отправляет пользователей по адресу
          <a href="https://www.googleapis.com/oauth2/v4/token"
            >https://www.googleapis.com/oauth2/v4/token</a
          >
          для авторизации в Google и не получает прямого доступа и не собирает
          пользовательские данные, используемые Google Auth.
        </p>

        <h2>Использование пользовательских данных</h2>
        <p>
          iRidium Assistant получает данные для использования в проекте iRidium
          только после того, как вы предоставите токен, который требует, чтобы
          вы аутентифицировались как конкретный пользователь Google и
          авторизовались для интеграцией с системой управления умным домом.
        </p>
        <p></p>
        <p>
          iRidium Assistant может помочь вам получить токен, направляя вас через
          механизм OAuth в браузере. Там вы должны дать согласие на работу
          приложения iRidium Assistant от вашего имени. Экран согласия OAuth
          будет описывать объем авторизации, например он укажет целевой API и
          разрешите ли вы доступ «только для чтения» или «для чтения и записи».
        </p>

        <h2>Области</h2>
        <p>
          Область <code>userinfo.email</code> (просмотр своего адреса
          электронной почты), область<code>userinfo.profile</code> (см. вашу
          личную информацию. включая любую личную информацию, которую вы сделали
          общедоступной) и область <code>openid</code> (аутентификация с помощью
          OpenID Connect) обязательны для использования Google Auth.
        </p>
        <p>
          iRidium Assistant позволяет вам управлять устройствами Google Nest,
          поэтому области по умолчанию также включают в себя
          <code>.../auth/sdm_fleet.service</code> (See and/or control Google
          Nest linked devices and services) и <code>.../auth/nest</code> (View
          and modify data shared by Nest devices).
        </p>
        <h2>Обмен пользовательскими данными</h2>
        <p>
          iRidium Assistant взаимодействует только с API Google. Никакие
          пользовательские данные не передаются владельцам проекта iRidium, GCP
          Project или любой другой стороне.
        </p>

        <h2>Хранение пользовательских данных</h2>
        <p>
          iRidium Assistant хранит только токены об успешной авторизации через
          Google OAuth для последующего использования вами в вызовах к [Smart
          Device Management API]. Предварительно авторизовавшись в системе
          iRidium Assistant, на странице
          <a href="https://cws.iridi.com/services/oauth/i3pro/nest"
            >https://cws.iridi.com/services/oauth/i3pro/nest</a
          >
          вы можете получить iRidium token и структуру устройств Google Nest для
          использования при создания i3pro проекта.
        </p>
        <p>
          iRidium token и структура устройств Google Nest хранятся в облаке
          проектов iRidium, а также на локальном устройстве пользователя
          (iRidium server), в случае, если проект был загружен и запущен на
          iRidium server.
        </p>
        <h2>Использование в других пакетах или приложениях</h2>
        <p>
          Не используйте информацию о структуре устройств или iRidium token
          объекта из iRidium Assistant во внешнем сервисе или инструменте.
          Согласно
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            >Политике данных пользователей Google</a
          >
          ваше приложение должно точно представлять себя при аутентификации в
          службах Google API.
        </p>
        <p>
          Если вы используете iRidium Assistant внутри другого сервиса или
          приложения, которое выполняет свою собственную логику - в отличие от
          кода в iRidium Assistant или пользователем, - вы должны четко сообщить
          об этом конечному пользователю.
        </p>
        <p></p>

        <h2>Изменения политики конфиденциальности</h2>
        <p>
          iRidium Assistant может изменять или обновлять данную Политику
          конфиденциальности в любое время, поэтому, пожалуйста, периодически
          пересматривайте её. Мы можем направлять Вам дополнительные уведомления
          в соответствующих случаях в зависимости от ситуации. Если Вы
          продолжите пользоваться iRidium Assistant или его сервисами после
          внесения каких-либо изменений в данную Политику конфиденциальности, то
          это будет означать, что Вы приняли указанные изменения.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  // data() {
  //   return {

  //   }
  // },
  // mounted(){
  //   this.$i18n.locale
  // }
}
</script>

<style>
.code,
code {
  background: rgba(135, 131, 120, 0.15);
  border-radius: 3px;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 85%;
  tab-size: 2;
}

code {
  color: #eb5757;
}

.code {
  padding: 1.5em 1em;
}

.code-wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

.code > code {
  background: none;
  padding: 0;
  font-size: 100%;
  color: inherit;
}

blockquote {
  font-size: 1.25em;
  margin: 1em 0;
  padding-left: 1em;
  border-left: 3px solid rgb(55, 53, 47);
}
</style>
